import { handleErrors } from "@/utils/handle-errors";
import { SdkUser } from "@/interfaces/sdk-user";
import fetch from "@mv/flow-shared-utils/functions/fetch";
export const saveUser = (user: SdkUser) => ({ type: "saveUser", user });
export const updateUser = (user: SdkUser) => ({ type: "updateUser", user });
export const loadAllUser = (params?: { [key: string]: string | number }) => ({ type: "loadAllUser", params });
export const loadUser = (userId: number) => ({ type: "loadUser", userId });
export const toggleSuperUserStatus = (userName: string, status: boolean) => ({ type: "toggleSuperUserStatus", userName, status });

export const actions = {
  loadAllUser(context: any, { params }: { params: {} }) {
    const urlParams = params ? `?${new URLSearchParams(params).toString()}` : "";
    return fetch(`core/api/user${urlParams}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadUser(context: any, { userId }: { userId: number }) {
    return fetch(`core/api/user/${userId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  saveUser(state: any, { user }: { user: SdkUser }) {
    return fetch(`core/api/user`, {
      method: "POST",
      body: JSON.stringify(user),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  updateUser(state: any, { user }: { user: SdkUser }) {
    return fetch(`core/api/user`, {
      method: "PUT",
      body: JSON.stringify(user),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  toggleSuperUserStatus(state: any, { userName, status }: { userName: string; status: boolean }) {
    return fetch(`core/api/user/${userName}/super-user/${status}`, {
      method: "PATCH",
    })
      .then(handleErrors)
      .then((data) => data);
  },
};
